<template>
    <b-container class="pb-2 bg-light mt-2 rounded">
        <page-heading heading="Overseas Institutes"/>

        <b-col col="9" class="mx-auto text-justify">
            <p class="lead">
                MQA‘s recognition of overseas institutions/colleges/universities is based on the following criterion:
            </p>
            <ul class="list-unstyled lead">
                <li>- Recognition of the institution/college/university in that particular country</li>
            </ul>
            <p class="lead">
                MQA's recognition of an institution/college/university does not mean that all it’s qualifications are recognized. Qualifications are Recognized and accepted in the Maldives.
            </p>
            <ul class="list-unstyled lead">
                <li>- If they are issued by a Government recognized institution in the country of origin.</li>
                <li>- If they meet standards and criteria set by the Maldives National Qualifications Framework (MNQF).</li>
            </ul>
            <p class="lead">
                For recognition of a program prior to joining the program, MQA provides the service of checking the recognition status of academic programs and institutes for individuals. Fill up the form , “Application form for institute and program recognition” and send it over with the required documents to MQA, 2nd floor, Velaanaage, by email to <a href="mailto:info@mqa.gov.mv">info@mqa.gov.mv.</a> Note that this is a free service.
            </p>
        </b-col>
    </b-container>
</template>
<script>
import PageHeading from '@/components/SharedComponents/PageHeading.vue'
export default {
    data() {
        return{
            institutes: [],
            tabs: ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X',   'Y','Z'],
        }
    },
    methods: {
        
    },
    components: {
        PageHeading
    },
    beforeCreate() {
        document.title ="Overseas Institutes"
    },
    created() {
        
    },
    beforeMount() {
        
    },
    mounted() {
        
    },
    beforeUpdate() {
        
    },
    updated() {

    }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/SharedComponents/Overseas.vue